import React, { useRef } from 'react';
import ProductCard from './ProductCard';

// A horizontally scrolling row of product cards with optional arrows.
const ProductRail = ({ title, note, products = [], action }) => {
  const trackRef = useRef(null);
  if (!products.length) return null;
  const scroll = (dir) => {
    const el = trackRef.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: 'smooth' });
  };
  return (
    <section className="m-section m-rail">
      <div className="m-section-head">
        <div>
          <h2 className="m-section-title">{title}</h2>
          {note && <p className="m-section-note">{note}</p>}
        </div>
        <div className="m-rail-tools">
          {action}
          {products.length > 4 && (
            <>
              <button type="button" className="m-rail-arrow" onClick={() => scroll(-1)} aria-label={`Scroll ${title} left`}>‹</button>
              <button type="button" className="m-rail-arrow" onClick={() => scroll(1)} aria-label={`Scroll ${title} right`}>›</button>
            </>
          )}
        </div>
      </div>
      <div className="m-rail-track" ref={trackRef}>
        {products.map((p) => (
          <div className="m-rail-item" key={p._id}>
            <ProductCard product={p} hideBadge={true} hideMeta={true} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRail;
